"use client";
import React from "react";
import Trans from "@/components/shared/Trans";
import translations from "../FichaInfo.trans.json";
import { Box, Text } from "@quintoandar-tokko/jopijs";
import style from "../fichaInfo.module.scss";
import { useSelector } from "react-redux";
import Skeletons from "../skelenton/Skeleton";

function ImportantNote() {
  const { user_language, loading } = useSelector((ste) => ste.FichaInfoSlice);

  if (loading)
    return (
      <Box __css={{ marginTop: "-16px" }}>
        <Skeletons width={"100%"} height={78} />
      </Box>
    );
  return (
    <Box
      __css={{ marginTop: "-16px" }}
      className={style.footNote}
      variant="normal"
    >
      <Text variant="body.fontSize13">
        {Trans(translations, "ImportantNote", user_language)}
      </Text>
    </Box>
  );
}

export default ImportantNote;
